import React from "react";
import ReactDOM from "react-dom/client";
import ReactModal from "react-modal";
import { Provider } from "react-redux";
import App from "./App";
import store from "./app/store";
import reportWebVitals from "./reportWebVitals";

import "./styles/index.css";

// Ensure react-modal knows which element is your app root
const container = document.getElementById("root");
if (!container) throw new Error("Root element #root not found");
ReactModal.setAppElement(container);

const root = ReactDOM.createRoot(container);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// Optional: CRA performance reporting
reportWebVitals();
